import { createStore } from "vuex";

export default createStore({
  state: {
    posts: [],
    loginState: false,
    isLoading: false,
    //host: "http://localhost/grand-heart-info",
    host: "http://grand-heart-info.dreamvision.jp",
  },
  mutations: {},
  actions: {},
  modules: {},
});
